module.exports = __webpack_public_path__ + "static/media/dropdownArrow.c1bdead1.svg";